import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQLMutationPrimitive,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { transformCartBenefits } from '../../../mapper';
import { IVoucherUpdateData } from '../model';

import { ADD_VOUCHER_MUTATION_V2 } from './addVoucherMutation';
import { IAddVouchersResponse, IPostVoucher } from './model';

const mappingFunction = (result: IAddVouchersResponse): IGeneralRequestResponse<IVoucherUpdateData> => ({
  ...result.addVoucher,
  data: {
    ...result.addVoucher.data,
    benefits: transformCartBenefits(result.addVoucher.data.benefits),
  },
});

export const usePostVoucherAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<IVoucherUpdateData>,
  IPostVoucher
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IVoucherUpdateData>,
    IGraphQLMutationPrimitive<IPostVoucher>,
    IAddVouchersResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.ECartPageApiKeys.CART_PAGE_ADD_VOUCHERS_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(
    (data?: IPostVoucher) => {
      return awaitableRequest({
        data: { query: ADD_VOUCHER_MUTATION_V2 },
        restUrlParams: [{ name: 'voucherCode', value: data?.voucher.code ?? '' }],
      });
    },
    [awaitableRequest],
  );

  return { request };
};
